export enum RecongnizebleFileFormats {
  Edm = 'edm',
  Pdf = 'pdf',
  Excel = 'excel',
}

export enum AvailableViewers {
  Json = 'json',
  Pdf = RecongnizebleFileFormats.Pdf,
  Table = 'table',
  Graph = 'graph',
  Excel = RecongnizebleFileFormats.Excel,
  Image = 'image',
  IPMFile = 'IPMFile',
}

export enum RecongnizebleEDMData {
  CD_SURVEY_STATION = 'CD_SURVEY_STATION',
  CD_DEFINITIVE_SURVEY_STATION = 'CD_DEFINITIVE_SURVEY_STATION',
  CD_DEFINITIVE_SURVEY_HEADER = 'CD_DEFINITIVE_SURVEY_HEADER',
  CD_SURVEY_HEADER = 'CD_SURVEY_HEADER',
  CD_PORE_PRESSURE = 'CD_PORE_PRESSURE',
  CD_FRAC_GRADIENT = 'CD_FRAC_GRADIENT',
  CD_WELLBORE = 'CD_WELLBORE',
  DP_TOOL_TERM = 'DP_TOOL_TERM',
  CD_SURVEY_TOOL = 'CD_SURVEY_TOOL',
  CD_WELL = 'CD_WELL',
  CD_SITE = 'CD_SITE',
  CD_PROJECT = 'CD_PROJECT',
  CD_SCENARIO = 'CD_SCENARIO',
  CD_DATUM = 'CD_DATUM',
  CD_TEMP_GRADIENT_GROUP = 'CD_TEMP_GRADIENT_GROUP',
  CD_RIG = 'CD_RIG',
  DP_MAGNETIC = 'DP_MAGNETIC',
  CD_HOLE_SECT_GROUP = 'CD_HOLE_SECT_GROUP',
  CD_HOLE_SECT = 'CD_HOLE_SECT',
  CD_SURVEY_PROGRAM= 'CD_SURVEY_PROGRAM',
}

export enum PossibleEDMDTables {
  TieOn = 'TieOn',
  FracturePressure = 'FracturePressure',
  FracturePressureP10 = 'FracturePressureP10',
  FracturePressureP50 = 'FracturePressureP50',
  FracturePressureP90 = 'FracturePressureP90',
  PorePressure = 'PorePressure',
  PorePressureP10 = 'PorePressureP10',
  PorePressureP50 = 'PorePressureP50',
  PorePressureP90 = 'PorePressureP90',
  LocationData = 'LocationData',
  SurveyPlan = 'SurveyPlan',
  ParametricDefinition = 'ParametricDefinition',
  SurveyRun = 'SurveyRun',
  ProjectData = 'ProjectData',
  WellboreWellheadPosition = 'WellboreWellheadPosition',
  CollapsePressure = 'CollapsePressure',
  CollapsePressureP10 = 'CollapsePressureP10',
  CollapsePressureP50 = 'CollapsePressureP50',
  CollapsePressureP90 = 'CollapsePressureP90',
  MinimumHorizontalStressPressure = 'MinimumHorizontalStressPressure',
  MinimumHorizontalStressPressureP10 = 'MinimumHorizontalStressPressureP10',
  MinimumHorizontalStressPressureP50 = 'MinimumHorizontalStressPressureP50',
  MinimumHorizontalStressPressureP90 = 'MinimumHorizontalStressPressureP90',
  TemperatureDefinition = 'TemperatureDefinition',
  TemperatureListing = 'TemperatureListing',
  SurveyProgram = 'SurveyProgram',
  DefinitiveSurveyRun = 'DefinitiveSurveyRun',
  GeomagneticParameters = 'GeomagneticParameters',
  ErrorVectors = 'ErrorVectors', // may be redundant and replaced by UncertaintyVectors
  CovarianceMatrix = 'CovarianceMatrix',
  PositionalUncertaintyList = 'PositionalUncertaintyList',
  Formations = 'Formations',
  IPMFile = 'IPMFile',
  CoordinateReferenceSystem = 'CoordinateReferenceSystem',
  UncertaintyVectors = 'UncertaintyVectors',
  PositionalUncertaintyMap = 'PositionalUncertaintyMap',
  CovarianceMatrixTotalMap = 'CovarianceMatrixTotalMap',
  GeomagneticParametersMap = 'GeomagneticParametersMap',
  TrajectoryPlan = 'TrajectoryPlan',
  HoleSize = 'HoleSize',
  SiteReferenceSystem = 'SiteReferenceSystem',
}

export enum RecongnizebleEDMHIerchyData {
  CD_SITE = 'CD_SITE',
}

export enum RecognisedDataCatalogues {
  ProjectData = 'Project Data',
  CoordinateReferenceSystem = 'Coordinate Reference System',
  WellboreWellheadPosition = 'Wellbore / Wellhead position',
  PorePressure = 'Pore Pressure',
  FracturePressure = 'Fracture Pressure',
  CollapsePressure = 'Collapse Pressure',
  MHSPressure = 'Minimum Horizontal Stress Pressure',
  GeothermalTemperature = 'Geothermal Temperature Table',
  TrajectoryPlan = 'Trajectory Plan',
  SurveyRuns = 'Survey Runs',
  SurveyProgram = 'Survey Program', // renamed as part of https://oliasoft.atlassian.net/browse/OW-23677
  DefinitiveSurveyList = 'Definitive Survey List',
  ToolsIPMfiles = 'Tools / IPM files',
  WellborePositionUncertainty = 'Wellbore Position Uncertainty',
  UncertaintyVectors = 'Uncertainty Vectors',
  GeomagneticParametersDefinition = 'Geomagnetic Parameters Definition',
  CovarianceMatrixTotal = 'Covariance Matrix Total',
  HoleSize = 'Hole Size',
  SiteReferenceSystem = 'Site Reference System',
}

export enum RecognisedDataObjects {
  PorePressureP10 = 'Pore Pressure (P10)',
  PorePressureP50 = 'Pore Pressure (P50)',
  PorePressureP90 = 'Pore Pressure (P90)',
  FracturePressureP10 = 'Fracture Pressure (P10)',
  FracturePressureP50 = 'Fracture Pressure (P50)',
  FracturePressureP90 = 'Fracture Pressure (P90)',
  CollapsePressureP10 = 'Collapse Pressure (P10)',
  CollapsePressureP50 = 'Collapse Pressure (P50)',
  CollapsePressureP90 = 'Collapse Pressure (P90)',
  MinimumHorizontalStressPressureP10 = 'Minimum Horizontal Stress Pressure (P10)',
  MinimumHorizontalStressPressureP50 = 'Minimum Horizontal Stress Pressure (P50)',
  MinimumHorizontalStressPressureP90 = 'Minimum Horizontal Stress Pressure (P90)',
  GeothermalTemperatureDefinition = 'Geothermal Temperature Definition',
  GeothermalTemperatureListing = 'Geothermal Temperature Listing',
  SurveyRun = 'SurveyRun',
  IPMFile = 'IPM File',
  CovExternal = 'COV External',
  CovWelldesign = 'COV Welldesign',
}

export type RecognisedDataLabels = RecognisedDataCatalogues | RecognisedDataObjects;

export enum DataSourceType {
  Edm = 'EDM',
}

export enum RecognisedHeaderLabels {
  Azimuth = 'Azimuth',
  Build = 'Build',
  Dogleg = 'Dogleg',
  TVD = 'TVD',
  DepthTVD = 'Depth TVD',
  DepthMD = 'Depth MD',
  ProjectTD = 'Project to TD',
  DepthFrom = 'Depth From',
  DepthTo = 'Depth To',
  DrillfloorHeight = 'Drillfloor Height',
  GroundElevation = 'Ground Elevation',
  ExtrapolateToBit = 'Extrapolate to Bit',
  ReferenceDepth = 'Reference Depth',
  PorePressureGradient = 'Pore Pressure Gradient',
  PorePressure = 'Pore Pressure',
  FracturePressureGradient = 'Fracture Pressure Gradient',
  FracturePressure = 'Fracture Pressure',
  CollapsePressureGradient = 'Collapse Pressure Gradient',
  CollapsePressure = 'Collapse Pressure',
  MinimumHorizontalStressPressureGradient = 'Minimum Horizontal Stress Pressure Gradient',
  MinimumHorizontalStressPressure = 'Minimum Horizontal Stress Pressure',
  Inclination = 'Inclination',
  LocalPositionEW = 'Local Position (East / West)',
  LocalPositionNS = 'Local Position (North / South)',
  Easting = 'Easting',
  Northing = 'Northing',
  SurveyDate = 'Survey Date',
  SurveyStatus = 'Survey Status',
  ReferenceWellboreID = 'Reference Wellbore ID',
  ReferenceSurveyRunID = 'Reference Survey Run ID',
  StartDepth = 'Start Depth',
  StartDepthReference = 'Start Depth Reference',
  SurveyRunName = 'Survey Run',
  Name = 'Name',
  Turn = 'Turn',
  ToolFace = 'Toolface',
  Tool = 'Tool',
  ToolModel = 'Tool Model',
  ToolID = 'Tool ID',
  SurveyRunID = 'Survey Run ID',
  VerticalSection = 'Vertical Section',
  Type = 'Type',
  TieOn = 'Tie-on',
  TieOnRun = 'Run',
  IPMFile = 'IPM File',
  GeomagneticParametersDefinition = 'Geomagnetic Parameters Definition',
  IncOnly = 'Inc Only',
  HoleSize = 'Hole Size',
  CovarianceMatrix = 'Covariance Matrix',
}
